<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <!-- Navigation Header -->
<!--    <AppHeader v-if="!isAuthPage" />-->
    
    <!-- Main Content -->
    <main :class="{ 'pt-16': !isAuthPage }">
      <router-view />
    </main>
    
    <!-- Footer -->
<!--    <AppFooter v-if="!isAuthPage" />-->
    
    <!-- Loading Overlay -->
    <LoadingOverlay v-if="isLoading" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useLoadingStore } from '@/stores/loading'
import LoadingOverlay from '@/components/common/LoadingOverlay.vue'

const route = useRoute()
const loadingStore = useLoadingStore()

// 인증 페이지인지 확인 (헤더/푸터 숨김용)
const isAuthPage = computed(() => {
  const authRoutes = ['/login', '/register', '/forgot-password']
  return authRoutes.includes(route.path)
})

// 전역 로딩 상태
const isLoading = computed(() => loadingStore.isLoading)
</script>

<style scoped>
#app {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 
               'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 
               'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
